<template>
  <div class="container">
    <!-- 进度条 -->
    <section class="progress_box">
      <section class="progress_item">
        <img :src="require(`../../assets/images/icon_check_${common.theme}.png`)" />
        <p class="status_cur">待处理</p>
        <p class="data">{{data.createTime | timeYmd}}</p>
        <p class="data">{{data.createTime | timeHmm}}</p>
        <span :class="['line',data.status == 1?'line_color':'']"></span>
      </section>
      <section class="progress_item">
        <span class="default_item" v-if="data.status != 1"></span>
        <img v-else :src="require(`../../assets/images/icon_check_${common.theme}.png`)" />
        <p :class="['status_cur',data.status == 1?'':'status_primary']">已处理</p>
        <p class="data" v-if="data.status == 1">{{data.updateTime | timeYmd}}</p>
        <p class="data" v-if="data.status == 1">{{data.updateTime | timeHmm}}</p>
        <span class="line"></span>
      </section>
    </section>
    <!-- 政策介绍 -->
    <section class="policy_box" @click="toPolicyDetail(data.sysPolicyId)">
      <section class="policy_box_left">
        <h2>{{data.title}}</h2>
        <section class="item_bottom_labal" v-if="data.tageName">
          <span v-for="item in data.tageName" :key="item"># {{item}}</span>
        </section>
      </section>
      <img class="policy_box_right" src="../../assets/images/icon_indicator_next.png" />
    </section>
    <!-- 咨询信息 -->
    <section class="consultation_mess" v-if="sysPolicyTypeValues.length">
      <h3>咨询信息</h3>
      <ul>
        <li v-for="(item,index) in sysPolicyTypeValues" :key="index">
          <p class="list_left">{{item.typeName}}</p>
          <p class="list_right">{{item.typeValue}}</p>
        </li>
      </ul>
    </section>
    <!-- 处理结果 -->
    <section class="consultation_mess end_message" v-if="data.dealResult">
      <h3>处理结果</h3>
      <p :class="['list_right',showMore?'showMore':'']">{{data.dealResult}}</p>
      <section class="img_box" v-if="data.dealResult.length > 52" @click="showMoreFun">
        <img v-if="!showMore" src="../../assets/images/down_icon.png" />
        <img v-else class="rotate" src="../../assets/images/down_icon.png" />
      </section>
    </section>
  </div>
</template>

<script>
import util from "../../utils/util";
import { getAdviceById } from "../../utils/api";
import { mapState } from "vuex";
export default {
  name: "myConsultationDetail",
  data() {
    return {
      sysPolicyTypeValues:[],
      data:{},
      showMore:false
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  filters: {
    timeYmd(val) {
      return util.formatTime(new Date(Number(val)), 4);
    },
    timeHmm(val) {
      return util.formatTime(new Date(Number(val)), 23);
    }
  },
  created(){
    this.getAdviceById()
  },
  methods: {
    getAdviceById(){
      util.showLoading()
      getAdviceById({id:this.$route.query.id}).then(res=>{
        console.log(res)
        if(res.res.code === 10000){
          let data = res.body.policyAdvice;
          let newData = []
          if(data.tageName){
            data.tageName = data.tageName.split(/[\s+,，]/g).slice(0,2)
          }
          data.sysPolicyTypeValues.forEach(item=>{
            if(item.typeValue){
              newData.push(item)
            }
          })
          this.data = data
          this.sysPolicyTypeValues = newData
          util.hideLoading()
        }else{
          util.hideLoading()
          util.showToast(res.res.msg)
        }
      })
    },
    toPolicyDetail(id){
      this.$router.push(`/policyDetail?id=${id}`)
    },
    showMoreFun(){
      this.showMore = !this.showMore;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background: #eee;
}
.progress_box {
  width: 100%;
  height: 240px;
  background: #fff;
  margin-bottom: 14px;
  .flex();
  .progress_item {
    flex: 1;
    .flex();
    flex-direction: column;
    align-items: center;
    position: relative;
    margin-top: 32px;
    &:last-child {
      .line {
        width: 0;
      }
    }
    img {
      display: block;
      width: 36px;
      height: 36px;
      padding: 8px;
      position: relative;
      z-index: 3;
      background: #fff;
    }
    .default_item {
      display: block;
      width: 16px;
      height: 16px;
      border-radius: 100%;
      border: 18px solid #fff;
      background: #eee;
      position: relative;
      z-index: 3;
    }
    .status_cur {
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
      line-height: 40px;
      margin-bottom: 10px;
    }
    .status_primary {
      color: #999;
    }
    .data {
      font-size: 24px;
      color: rgba(153, 153, 153, 1);
      line-height: 24px;
    }
    .line {
      position: absolute;
      top: 22px;
      left: 50%;
      height: 4px;
      width: 100%;
      background: #f4f4f4;
      z-index: 2;
    }
    .line_color{
      background: @color17;
    }
  }
}
// 政策介绍
.policy_box {
  padding: 28px;
  background: #fff;
  margin-bottom:14px;
  .flex();
  align-items: center;
  .policy_box_left {
    flex: 1;
    .flex();
    flex-direction: column;
    justify-content: space-between;

    h2 {
      height: 44px;
      font-size: 32px;
      color: rgba(24, 24, 24, 1);
      line-height: 44px;
      font-weight: bold;
      .textOver(642px);
      margin-bottom: 28px;
    }
    .item_bottom_labal {
      .flex();
      span {
        display: block;
        margin-right: 10px;
        margin-bottom: 10px;
        // min-width: 160px;
        padding:0 10px;
        background: rgba(235, 239, 245, 1);
        border-radius: 4px;
        font-size: 24px;
        color: rgba(60, 100, 159, 1);
        line-height: 34px;
        text-align: center;
      }
    }
  }
  .policy_box_right {
    display: block;
    width: 32px;
    height: 32px;
    margin-left: 20px;
  }
}
// 咨询信息
.consultation_mess {
  background: #fff;
  margin-bottom: 14px;
  padding: 28px;
  h3 {
    height: 44px;
    font-size: 32px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 44px;
    padding-left: 18px;
    margin-bottom: 28px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 10px;
      width: 6px;
      height: 24px;
      background: @color17;
    }
  }
  ul {
    li {
      .flex();
      margin-bottom: 20px;
      &:last-child{
        margin-bottom:0;
      }
      .list_left {
        width: 140px;
        font-size: 26px;
        color: rgba(153, 153, 153, 1);
        line-height: 36px;
      }
      .list_right {
        flex:1;
        font-size: 26px;
        color: rgba(51, 51, 51, 1);
        line-height: 36px;
        word-break:break-all;
      }
    }
  }
}
.end_message{
  .list_right{
    flex:1;
    font-size: 26px;
    color: rgba(51, 51, 51, 1);
    line-height: 36px;
    word-break:break-all;
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    transition: all 0.5s ease-in-out;
    max-height:72px;
  }
  .showMore{
    max-height:10000px;
    -webkit-line-clamp: 200;
    transition: all 0.5s ease-in-out;
  }
  img{
    width:34px;
    height:34px;
    margin:0 auto;
    display: block;
    &.rotate{
      transform: rotate(180deg);
      transition: all 0.3s ease-in-out;
    }
  }
}
</style>